import { render, staticRenderFns } from "./analyze.vue?vue&type=template&id=20fd5394&scoped=true&"
import script from "./analyze.vue?vue&type=script&lang=js&"
export * from "./analyze.vue?vue&type=script&lang=js&"
import style0 from "./analyze.vue?vue&type=style&index=0&id=20fd5394&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fd5394",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20fd5394')) {
      api.createRecord('20fd5394', component.options)
    } else {
      api.reload('20fd5394', component.options)
    }
    module.hot.accept("./analyze.vue?vue&type=template&id=20fd5394&scoped=true&", function () {
      api.rerender('20fd5394', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chronic/components/analyze.vue"
export default component.exports